import {
    AlgorithmParametersRevisionIndexAction,
    AlgorithmParametersRevisionIndexActionType,
} from './actions';
import {
    AlgorithmParametersRevisionIndexState,
    initialAlgorithmParametersRevisionIndexState,
} from './AlgorithmParametersRevisionIndexState';

export default function revisionIndexReducer(
    state: AlgorithmParametersRevisionIndexState = initialAlgorithmParametersRevisionIndexState,
    action: AlgorithmParametersRevisionIndexAction
): AlgorithmParametersRevisionIndexState {
    switch (action.type) {
        case AlgorithmParametersRevisionIndexActionType.ALGORITHM_PARAMETERS_SET_REVISION_INDEX:
            return isValidIndex(action.payload!.revisionIndex)
                ? action.payload!.revisionIndex
                : isValidIndex(state)
                ? state
                : initialAlgorithmParametersRevisionIndexState;
        case AlgorithmParametersRevisionIndexActionType.ALGORITHM_PARAMETERS_INCREMENT_REVISION_INDEX:
            return isValidIndex(state)
                ? state! + 1
                : initialAlgorithmParametersRevisionIndexState;
        case AlgorithmParametersRevisionIndexActionType.ALGORITHM_PARAMETERS_DECREMENT_REVISION_INDEX:
            return isValidIndex(state)
                ? state! > 0
                    ? state! - 1
                    : state!
                : initialAlgorithmParametersRevisionIndexState;
    }
    return state;
}

function isValidIndex(index: number | null) {
    return isWholeNumber(index) && index! >= 0;
}

function isWholeNumber(val: number | null) {
    return val !== null && val % 1 === 0;
}
